import {Component, Vue} from "vue-property-decorator";
import HeroLoader from "~/components/hero-loader";
import {Customisation} from "~/lib/models/customisation";
import {getPublicCustomisation} from "~/modules/customisation/service";
import injectStyle from "~/modules/customisation/style-injector";
import frameImage from "~/assets/inline-svg/frame_login.svg?inline";
import "./auth-screen-mixins.style.scss";
import { getFileSrc } from "~/lib/helpers";
import { Logo, LogoConfig } from "~/components/logo";
import { MessageBoxError } from "~/components/message-box";

const defaultFrameMessages = [
  { title: "Faites parler vos données !", description: "Avec Geoptis Solution, vous entrez dans un monde de données et de cartes faciles à consulter pour éclairer vos choix."}, 
  { title: "À vous les données utiles et lisibles", description: "Consultez sur des cartes vos données et les nôtres pour prendre des décisions objectives."}, 
  { title: "Révélons les données territoriales", description: "Geoptis Solution vous facilite l'accès et la compréhension des données, pour nourrir votre réflexion et éclairer vos choix."}
]

@Component
class AuthScreenMixin extends Vue {

  public customisation: Customisation = null;
  protected isReady: boolean = false;
  private depError = null;

  get code(){
    return this.$route.query.code ? decodeURIComponent((this.$route.query.code as string)) : null
  }

  async created() {    try {

      const idKey = this.$route.query.id_key as string;
      this.customisation = await getPublicCustomisation(idKey);
      this.isReady = true;
      injectStyle(this.customisation);
    } catch (err) {
      this.depError = "Une erreur est survenue, veuillez contacter le support.";
    }

  }

  get defaultFrameMessage() {
    const frameIdx = Math.floor(Math.random() * 3);
    return defaultFrameMessages[frameIdx];
  }

  get hasCustomColor() {
    return (new Customisation()).colors.primary !== this.customisation.colors.primary;
  }

  protected renderErrored(msg) {
    return (
      <div class="field error-field">
        <MessageBoxError class="is-6">{msg}</MessageBoxError>
      </div>
    );
  }

  protected renderTitle() {
    if (this.customisation?.title) {
      return <h1 class="signin_title">{this.customisation.title}</h1>;
    }
    return null;
  }

  protected renderLogoCustomization() {

    if( ! this.customisation.signinPage.logo ) return null;

    let logos: LogoConfig[] = [this.customisation.signinPage.logo];
    if (this.customisation.signinPage?.subLogo?.fileId) logos.push(this.customisation.signinPage.subLogo); 

    return (
      <div class="logos">
        {logos.map(logo => <Logo logo={logo} />)}
      </div>
    );
  }

  protected renderPoweredBy() {

    const poweredBy = this.customisation.signinPage?.poweredBy;
    if (poweredBy.fileId) {
      return (
        <div class="powered-by" style={{width: poweredBy.width || "75px" }}>
          <img src={`${getFileSrc(poweredBy.fileId)}`} alt="Logo"/>
        </div>
      );
    }
  }

  renderBackground() {
    if (this.customisation?.signinPage?.background?.image) {
      return <img class="image-background"
                  src={`${getFileSrc(this.customisation.signinPage.background.image)}`}/>;
    }
  }

  renderFrame(i = null) {
    return (
      <div class="signin-frame">
        <div class={["frame-image", {"custom-color": this.hasCustomColor}]} domPropsInnerHTML={frameImage} />
        <div class="frame-infos">
          <h2>{i ? i.title : this.defaultFrameMessage.title}</h2>
          <p>{i ? i.description : this.defaultFrameMessage.description}</p>     
        </div>
     </div>
    )
  }

  protected renderLoadingState() {
    return (
      <div class="hero is-fullheight">
        <HeroLoader/>
      </div>
    );
  }

  protected wrapRenderer(renderer) {

    if( this.depError){
      return <div class="dep-error">
        {this.renderBackground()}
        <section class="signin">
          <div class="inner">
            {this.renderErrored(this.depError)}
          </div>
        </section>
      </div>
    }

    if (!this.isReady) {
      return this.renderLoadingState();
    }

    return renderer();
  }

}

export {AuthScreenMixin};


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-6cda7401/auth-screen-mixins.tsx" });